import axios from "axios";

export const axiosInstance = axios.create({});

export const apiConnector = async (method, url, bodyData = null, headers = null, params = null) => {
    try {
        const response = await axiosInstance({
            method,
            url,
            data: bodyData,
            headers: headers,
            params: params,
        });
        if (response.statusText === 'pending') {
            throw new Error('Request is still pending')
        }
        return response;
    } catch (error) {
        console.error("API request failed apiConnector: ", error);
        throw error;
    }
};
